jQuery(document).ready(function ($) {
	// Selecciona solo las columnas dentro del bloque específico
	$('.wp-block-plune-blocks-slider-images .wp-block-columns').each(function() {
		var $columns = $(this);
		if ($(window).width() <= 768) {
			$columns.addClass('owl-carousel').owlCarousel({
				loop: false,
				margin: 10,
				nav: true,
				dots: true,
				navText: ['<i class="fa-regular fa-arrow-left"></i>', '<i class="fa-regular fa-arrow-right"></i>'],
				responsive: {
					0: {
						items: 1,
						stagePadding: 70,
					},
					430: {
						items: 2,
						stagePadding: 70,
					}
				}
			});
		}

		// Fancybox logic
		if ($columns.data('fancybox-enabled')) {
			$columns.find('a[href]').each(function() {
				const imageSrc = $(this).attr('href');
				$(this).attr('data-fancybox', 'gallery');
				$(this).attr('href', imageSrc);
			});
		}
	});
});
